import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "BankOfZS",
  "use": "BankOfZS-usage",
  "viewBox": "0 0 68 68",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 68 68\" id=\"BankOfZS\">\r\n<defs>\r\n    <style>\r\n      #BankOfZS .cls-1 {\r\n        fill: #c7162e;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"BankOfZS_招行logo\" class=\"cls-1\" d=\"M1893.46,220.257l-9.71,23.732h38.61l-9.7-23.834-9.61,23.52-9.58-23.418h-0.01Zm37.81,18.052h7.71q-0.225.864-.48,1.719h-6.55Zm-1.3-3.231h9.65c-0.08.577-.19,1.146-0.3,1.715h-8.66Zm-1.3-3.231h11.28c-0.03.573-.08,1.146-0.13,1.715h-10.46Zm-1.3-3.235h12.6c0.02,0.463.03,0.926,0.03,1.393v0.327h-11.94l-0.69-1.72h0Zm-1.29-3.226h13.61c0.08,0.564.14,1.137,0.19,1.715h-13.11l-0.69-1.72v0Zm-1.3-3.236h14.31q0.2,0.853.36,1.72h-13.99l-0.68-1.72h0ZM1872,230.005a34,34,0,0,1,66.69-9.37h-14.52l-8.47-21.1-9.5,23.6-9.7-23.392-17.96,44.237,7.33,10.313h40.57l7.02-10.521-0.9-2.237h5.43A34,34,0,0,1,1872,230.005h0Zm0,0\" transform=\"translate(-1872 -196)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/BankOfZS.svg
// module id = fTEo
// module chunks = 37